import { memo } from "react";
import styled from "styled-components";
import { TextBody } from "components";

function RowFooterSuratJalan({ allData, isSuratJalan, selectedData }) {
  const calcReqQTY = () => {
    let totalReqQty = 0;
    [...allData].map((items) => {
      totalReqQty += items.product_request_quantity;
      return items.product_incoming_quantity;
    });

    return totalReqQty;
  };

  const calcActualQTY = () => {
    let totalReqQty = 0;
    [...allData].map((items) => {
      totalReqQty += items.product_incoming_quantity;
      return items.product_actual_quantity;
    });

    return totalReqQty;
  };

  return (
    <Tr
      topCurvedt=" 0px 0px 18px 18px"
      borderLineLeft
      borderLineRight
      borderLineBottom
    >
      <Td width="4%">
        <TDWrapper>
          <TextBody size="toast"></TextBody>
        </TDWrapper>
      </Td>
      <Td width="16%">
        <TDWrapper>
          <TextBody size="toast"></TextBody>
        </TDWrapper>
      </Td>
      <Td width="23%">
        <TDWrapper></TDWrapper>
      </Td>
      <Td width="12%">
        <TDWrapper>
          <CenterText>{calcReqQTY()}</CenterText>
        </TDWrapper>
      </Td>
      <Td width="10%">
        <TDWrapper>
          <CenterText></CenterText>
        </TDWrapper>
      </Td>
      <Td width="10%">
        <TDWrapper>
          <CenterText>{isSuratJalan && calcActualQTY()}</CenterText>
        </TDWrapper>
      </Td>
      <Td width="10%">
        <TDWrapper>
          <CenterText></CenterText>
        </TDWrapper>
      </Td>
      <Td width="15%" lastBR={true}>
        <TDWrapper></TDWrapper>
      </Td>
    </Tr>
  );
}

export default memo(RowFooterSuratJalan);

const Tr = styled.tr`
  display: flex;
  background-color: #fffae6;
  border-bottom: 1px solid #f3f6fa;
  align-items: stretch;
  ${({ borderLineTop }) => borderLineTop && `border-top: 1px solid #bfc9d6;`}
  ${({ borderLineLeft }) => borderLineLeft && `border-left: 1px solid #bfc9d6;`}
  ${({ borderLineRight }) =>
    borderLineRight && `border-right: 1px solid #bfc9d6;`}
    ${({ borderLineBottom }) =>
    borderLineBottom && `border-bottom: 1px solid #bfc9d6;`}
  
    border-radius: ${({ topCurvedt }) => {
    return topCurvedt ? topCurvedt : "";
  }};
`;
const Td = styled.td`
  color: ${({ theme: { colors } }) => colors.black};
  font-size: ${({ theme: { fontSizes } }) => fontSizes.smaller};
  //   flex: ${({ ratio }) => ratio};
  /* font-weight: ${({ theme: { fontWeights } }) => fontWeights.light}; */
  font-size: ${({ theme: { fontSizes } }) => fontSizes.smaller};
  //flex: ${({ ratio }) => ratio};
  width: ${({ width }) => (width ? width : "10%")};
  text-align: start;
  ${({ lastBR }) => !lastBR && `border-right: 1px solid #FFFAE6;`}
`;

const TDWrapper = styled.div`
  padding: 12px 8px;
`;
const CenterText = styled.p`
  text-align: center;
`;
